import { appFetchLogin } from './fetch';
import host from './host';

export const loginUser = async (username, password) => {
    const url = `${host}/login/dashboard`;
    return await appFetchLogin({ url, body: JSON.stringify({ username, password}), method: 'POST' });
};